import {Loading as AllCoachesReportContentLoading} from '/component/partial/reportCard/AllCoachesReportContent';
import {Loading as CloseToExecutiveDirectorLoading} from '/component/partial/reportCard/CloseToExecutiveDirectorReportContent';
import {Loading as CloseToFibcReportContentLoading} from '/component/partial/reportCard/CloseToFibcReportContent';
import {Loading as CloseToSeniorCoachReportContentLoading} from '/component/partial/reportCard/CloseToSeniorCoachReportContent';
import {Loading as CoachSearchContentLoading} from '/component/partial/reportCard/CoachSearchContent';
import {Loading as EarnedCabReportContentLoading} from '/component/partial/reportCard/EarnedCabReportContent';
import {Loading as EarnedCoachAcceleratorBonusReportContentLoading} from '/component/partial/reportCard/EarnedCoachAcceleratorBonusReportContent';
import {Loading as EarnedCSBPlusContentLoading} from '/component/partial/reportCard/EarnedCSBPlusReportContent';
import {Loading as EarnedQsbReportContentLoading} from '/component/partial/reportCard/EarnedQsbReportContent';
import {Loading as EligibleAcceleratorBonusReportContentLoading} from '/component/partial/reportCard/EligibleAcceleratorBonusReportContent';
import {Loading as EligibleClientSupportBonusPlusReportContentLoading} from '/component/partial/reportCard/EligibleClientSupportBonusPlusReportContent';
import {Loading as EligibleForCabReportContentLoading} from '/component/partial/reportCard/EligibleForCabReportContent';
import {Loading as EligibleForIncentiveTripLoading} from '/component/partial/reportCard/EligibleForIncentiveTripReportContent';
import {Loading as EligibleForQsbReportContentLoading} from '/component/partial/reportCard/EligibleForQsbReportContent';
import {Loading as ExpiringCoachRenewalsReportContentLoading} from '/component/partial/reportCard/ExpiringCoachRenewalsReportContent';
import {Loading as NewCoachesReportContentLoading} from '/component/partial/reportCard/NewCoachesReportContent';
import {Loading as PromotionReportContentLoading} from '/component/partial/reportCard/PromotionReportContent';
import {Loading as QualifiedForIncentiveTripLoading} from '/component/partial/reportCard/QualifiedForIncentiveTripReportContent';
import {Loading as TeamRankReportContentLoading} from '/component/partial/reportCard/TeamRankReportContent';
import {
  REPORT_CARD_CONTENT_ALL_COACHES,
  REPORT_CARD_CONTENT_CLOSE_TO_ED,
  REPORT_CARD_CONTENT_CLOSE_TO_FIBC,
  REPORT_CARD_CONTENT_CLOSE_TO_SC,
  REPORT_CARD_CONTENT_EARNED_CAB,
  REPORT_CARD_CONTENT_EARNED_QSB,
  REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB,
  REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB,
  REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL,
  REPORT_CARD_CONTENT_NEW_COACHES,
  REPORT_CARD_CONTENT_PROMOTION,
  REPORT_CARD_CONTENT_TEAM_RANK,
  REPORT_CARD_EARNED_ACCELERATOR_BONUS,
  REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
  REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP,
  REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP,
  SEARCH_CARD_COACHES_CONTENT,
} from '/enum/reportCard.enum';

export const ALL_CONTENT = {
  [REPORT_CARD_CONTENT_ALL_COACHES]: AllCoachesReportContentLoading,
  [REPORT_CARD_CONTENT_NEW_COACHES]: NewCoachesReportContentLoading,
  [REPORT_CARD_CONTENT_PROMOTION]: PromotionReportContentLoading,
  [REPORT_CARD_CONTENT_TEAM_RANK]: TeamRankReportContentLoading,
  [REPORT_CARD_CONTENT_CLOSE_TO_SC]: CloseToSeniorCoachReportContentLoading,
  [REPORT_CARD_CONTENT_EARNED_CAB]: EarnedCabReportContentLoading,
  [REPORT_CARD_CONTENT_EARNED_QSB]: EarnedQsbReportContentLoading,
  [REPORT_CARD_CONTENT_CLOSE_TO_ED]: CloseToExecutiveDirectorLoading,
  [REPORT_CARD_CONTENT_EXPIRING_COACH_RENEWAL]:
    ExpiringCoachRenewalsReportContentLoading,
  [REPORT_CARD_CONTENT_ELIGIBLE_FOR_CAB]: EligibleForCabReportContentLoading,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS]:
    EligibleClientSupportBonusPlusReportContentLoading,
  [REPORT_CARD_CONTENT_ELIGIBLE_FOR_QSB]: EligibleForQsbReportContentLoading,
  [REPORT_CARD_CONTENT_CLOSE_TO_FIBC]: CloseToFibcReportContentLoading,
  [SEARCH_CARD_COACHES_CONTENT]: CoachSearchContentLoading,
  [REPORT_CARD_EARNED_ACCELERATOR_BONUS]:
    EarnedCoachAcceleratorBonusReportContentLoading,
  [REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS]: EarnedCSBPlusContentLoading,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR]:
    EligibleClientSupportBonusPlusReportContentLoading,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX]:
    EligibleClientSupportBonusPlusReportContentLoading,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO]:
    EligibleClientSupportBonusPlusReportContentLoading,
  [REPORT_CARD_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE]:
    EligibleClientSupportBonusPlusReportContentLoading,
  [REPORT_CARD_ELIGIBLE_ACCELERATOR_BONUS]:
    EligibleAcceleratorBonusReportContentLoading,
  [REPORT_CARD_QUALIFIED_FOR_INCENTIVE_TRIP]: QualifiedForIncentiveTripLoading,
  [REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP]: EligibleForIncentiveTripLoading,
};
